import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-6 py-6 w-full h-full flex relative" }
const _hoisted_2 = { class: "relative z-50 w-full 2xl:w-1/2 h-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "relative z-50 w-full 2xl:w-1/2 ml-8 h-full" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "divide-x divide-gray-200 pl-4 py-8 inline-flex flex-col" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "font-medium text-2xl px-4 py-2 text-gray-900" }, " Radisol OÜ "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "mailto:tugi@radisol.ee",
      class: "inline-flex items-center px-5 py-2 text-base font-normal group"
    }, [
      /*#__PURE__*/_createElementVNode("svg", {
        "aria-hidden": "true",
        focusable: "false",
        class: "-ml-1 mr-4 h-5 w-5 text-gray-400 group-hover:text-gray-500 transition-all ease-in-out duration-200",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          fill: "currentColor",
          "stroke-width": "1",
          d: "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h416c8.8 0 16 7.2 16 16v41.4c-21.9 18.5-53.2 44-150.6 121.3-16.9 13.4-50.2 45.7-73.4 45.3-23.2.4-56.6-31.9-73.4-45.3C85.2 197.4 53.9 171.9 32 153.4V112c0-8.8 7.2-16 16-16zm416 320H48c-8.8 0-16-7.2-16-16V195c22.8 18.7 58.8 47.6 130.7 104.7 20.5 16.4 56.7 52.5 93.3 52.3 36.4.3 72.3-35.5 93.3-52.3 71.9-57.1 107.9-86 130.7-104.7v205c0 8.8-7.2 16-16 16z"
        })
      ]),
      /*#__PURE__*/_createElementVNode("span", { class: "text-gray-700 group-hover:text-gray-900 transition-all ease-in-out duration-200" }, "tugi@radisol.ee")
    ]),
    /*#__PURE__*/_createElementVNode("a", {
      href: "tel:+3725533611",
      class: "flex items-center px-5 py-2 text-base font-normal group"
    }, [
      /*#__PURE__*/_createElementVNode("svg", {
        "aria-hidden": "true",
        focusable: "false",
        class: "-ml-1 mr-4 h-5 w-5 text-gray-400 group-hover:text-gray-500 transition-all ease-in-out duration-200",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          fill: "currentColor",
          d: "M493.09 351.3L384.7 304.8a31.36 31.36 0 0 0-36.5 8.9l-44.1 53.9A350 350 0 0 1 144.5 208l53.9-44.1a31.35 31.35 0 0 0 8.9-36.49l-46.5-108.5A31.33 31.33 0 0 0 125 .81L24.2 24.11A31.05 31.05 0 0 0 0 54.51C0 307.8 205.3 512 457.49 512A31.23 31.23 0 0 0 488 487.7L511.19 387a31.21 31.21 0 0 0-18.1-35.7zM456.89 480C222.4 479.7 32.3 289.7 32.1 55.21l99.6-23 46 107.39-72.8 59.5C153.3 302.3 209.4 358.6 313 407.2l59.5-72.8 107.39 46z"
        })
      ]),
      /*#__PURE__*/_createElementVNode("span", { class: "text-gray-700 group-hover:text-gray-900 transition-all ease-in-out duration-200" }, "+372 553 3611")
    ]),
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "flex items-center px-5 py-2 text-base font-normal group"
    }, [
      /*#__PURE__*/_createElementVNode("svg", {
        "aria-hidden": "true",
        focusable: "false",
        class: "-ml-1 mr-4 h-5 w-5 text-gray-400 group-hover:text-gray-500 transition-all ease-in-out duration-200",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 496 512"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          fill: "currentColor",
          d: "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm193.2 152h-82.5c-9-44.4-24.1-82.2-43.2-109.1 55 18.2 100.2 57.9 125.7 109.1zM336 256c0 22.9-1.6 44.2-4.3 64H164.3c-2.7-19.8-4.3-41.1-4.3-64s1.6-44.2 4.3-64h167.4c2.7 19.8 4.3 41.1 4.3 64zM248 40c26.9 0 61.4 44.1 78.1 120H169.9C186.6 84.1 221.1 40 248 40zm-67.5 10.9c-19 26.8-34.2 64.6-43.2 109.1H54.8c25.5-51.2 70.7-90.9 125.7-109.1zM32 256c0-22.3 3.4-43.8 9.7-64h90.5c-2.6 20.5-4.2 41.8-4.2 64s1.5 43.5 4.2 64H41.7c-6.3-20.2-9.7-41.7-9.7-64zm22.8 96h82.5c9 44.4 24.1 82.2 43.2 109.1-55-18.2-100.2-57.9-125.7-109.1zM248 472c-26.9 0-61.4-44.1-78.1-120h156.2c-16.7 75.9-51.2 120-78.1 120zm67.5-10.9c19-26.8 34.2-64.6 43.2-109.1h82.5c-25.5 51.2-70.7 90.9-125.7 109.1zM363.8 320c2.6-20.5 4.2-41.8 4.2-64s-1.5-43.5-4.2-64h90.5c6.3 20.2 9.7 41.7 9.7 64s-3.4 43.8-9.7 64h-90.5z"
        })
      ]),
      /*#__PURE__*/_createElementVNode("span", { class: "text-gray-700 group-hover:text-gray-900 transition-all ease-in-out duration-200" }, "radisol.ee")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardHomeContactForm = _resolveComponent("DashboardHomeContactForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DashboardHomeContactForm)
    ]),
    _hoisted_3
  ]))
}